import React from 'react';
import PropTypes from 'prop-types';

export function RoundButton(props) {
	const { icon, height, text, textSpace } = props;
	return (
		<button
			type="button"
			className="flex flex-col items-center focus:outline-none">
			<img
				className={`bg-white shadow-lg rounded-full ${height}`}
				src={icon}
				alt="button" />
			{textSpace && <p className="text-xs h-4">{text}</p>}
		</button>
	);
}

RoundButton.propTypes = {
	icon: PropTypes.string,
	height: PropTypes.string,
	text: PropTypes.string,
	textSpace: PropTypes.bool
};
RoundButton.defaultProps = {
	icon: null,
	height: 'h-6',
	text: '',
	textSpace: PropTypes.false
};
